import { call, put, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";

import { startLoader, stopLoader } from "../../../../utils/commonFunctions";
import { CustomerVasActionTypes, CustomerVasActions } from "../../../actionTypes/master/customerVasActionTypes";
import { setPostApiStatus, setPutApiStatus } from "../../../actions/apiStatusActions";
import {
  createCustomerVasApi,
  editCustomerVasDataByIdApi,
  getCustomerVasDataByIdApi,
  getCustomerVasListApi,
} from "../../requests/master/customerVasRequests";
import {
  setCustomerVasDataById,
  setCustomerVasList,
  setCustomerVasListPageCount,
} from "../../../actions/master/customerVasActions";


function* createCustomerVasHandler(action: CustomerVasActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(createCustomerVasApi, action.payload);

    if (data.status) {
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(false));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getCustomerVasListHandler(action: CustomerVasActionTypes) {
  try {
    yield startLoader("transparent");

    const { data } = yield call(getCustomerVasListApi, action.payload);

    if (data.status) {
      yield put(setCustomerVasList(data?.data?.rows ?? []));
      yield put(setCustomerVasListPageCount(data?.data?.count ?? 0));
    } else {
      yield put(setCustomerVasList([]));
      yield put(setCustomerVasListPageCount(0));
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getCustomerVasDataByIdHandler(action: CustomerVasActionTypes) {
  try {
    const { data } = yield call(getCustomerVasDataByIdApi, action.payload);
    if (data.status) {
      yield put(setCustomerVasDataById(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  }
}

function* editCustomerVasDataByIdHandler(action: CustomerVasActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editCustomerVasDataByIdApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(false));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

export default function* customerVasSaga() {
  yield takeLatest(CustomerVasActions.CREATE_CUSTOMER_VAS, createCustomerVasHandler);
  yield takeLatest(CustomerVasActions.GET_CUSTOMER_VAS_LIST, getCustomerVasListHandler);
  yield takeLatest(CustomerVasActions.GET_CUSTOMER_VAS_DATA_BY_ID, getCustomerVasDataByIdHandler);
  yield takeLatest(CustomerVasActions.EDIT_CUSTOMER_VAS_DATA_BY_ID, editCustomerVasDataByIdHandler);
}
